export const IDI_DASHBOARD_START_LOADING = "IDI_DASHBOARD_START_LOADING";
export const IDI_DASHBOARD_END_LOADING = "IDI_DASHBOARD_END_LOADING";

export const SET_IDI_DASHBOARD_FILTER_SEARCH = "SET_IDI_DASHBOARD_FILTER_SEARCH";

export const IDI_DASHBOARD_DRAFT_LOADED = "IDI_DASHBOARD_DRAFT_LOADED";
export const IDI_DASHBOARD_NEW_LOADED = "IDI_DASHBOARD_NEW_LOADED";
export const IDI_DASHBOARD_DESIGN_REVIEW_LOADED = "IDI_DASHBOARD_DESIGN_REVIEW_LOADED";
export const IDI_DASHBOARD_DESIGN_REVIEW_ACCEPTED_LOADED = "IDI_DASHBOARD_DESIGN_REVIEW_ACCEPTED_LOADED";
export const IDI_DASHBOARD_DESIGN_REVIEW_REJECTED_LOADED = "IDI_DASHBOARD_DESIGN_REVIEW_REJECTED_LOADED";
export const IDI_DASHBOARD_UPLOADED_TO_BALADY_LOADED = "IDI_DASHBOARD_UPLOADED_TO_BALADY_LOADED";
export const IDI_DASHBOARD_FOUNDATION_LOADED = "IDI_DASHBOARD_FOUNDATION_LOADED";
export const IDI_DASHBOARD_GROUND_BEAM_LOADED = "IDI_DASHBOARD_GROUND_BEAM_LOADED";
export const IDI_DASHBOARD_COLUMNS_LOADED = "IDI_DASHBOARD_COLUMNS_LOADED";
export const IDI_DASHBOARD_SLAB_LOADED = "IDI_DASHBOARD_SLAB_LOADED";
export const IDI_DASHBOARD_WATER_PROOFING_LOADED = "IDI_DASHBOARD_WATER_PROOFING_LOADED";
export const IDI_DASHBOARD_FINISHES_LOADED = "IDI_DASHBOARD_FINISHES_LOADED";
export const IDI_DASHBOARD_PROJECT_COMPLETION_LOADED = "IDI_DASHBOARD_PROJECT_COMPLETION_LOADED";
export const IDI_DASHBOARD_COMPLETED_LOADED = "IDI_DASHBOARD_COMPLETED_LOADED";
export const IDI_DASHBOARD_CLOSED_LOADED = "IDI_DASHBOARD_CLOSED_LOADED";
export const IDI_DASHBOARD_CANCELLED_LOADED = "IDI_DASHBOARD_CANCELLED_LOADED";
export const IDI_DASHBOARD_ABORTED_LOADED = "IDI_DASHBOARD_ABORTED_LOADED";

export const IDI_DASHBOARD_USER_SEARCH_LOADED = "IDI_DASHBOARD_USER_SEARCH_LOADED";